import { Sizes } from 'styled-components';
import { styled } from '../../../core/theme/styled';

type ContainerProps = {
  margin?: Sizes;
};

export const Container = styled.div<ContainerProps>`
  width: 100%;
  display: grid;
  grid-template-columns: 10% 90%;
  margin: ${(props) => (props.margin ? props.theme.sizes[props.margin] : props.theme.sizes.normal)};
`;

export const TextContainer = styled.p`
  font-size: ${({ theme }) => theme.sizes.small};
`;
